//node modules
import "tw-elements";
import "./index.scss";

const FAQ = () => {
  return (
    <section
      id="faq-section"
      className="w-full flex justify-center bg-[url(../../assets/images/sss-bg.png)] bg-top bg-cover"
    >
      <div className="w-4/5 max-w-screen-xl py-28 space-y-7">
        <h4 className="text-white text-5xl sm:text-7xl font-bold ">SSS</h4>
        <div className="justify-center flex">
          <div className="accordion space-y-4 md:w-3/4" id="faq-accordion">
            <div className="accordion-item bg-transparent border rounded-none border-white ">
              <h2 className="accordion-header mb-0" id="1">
                <button
                  className="accordion-button collapsed relative flex items-center w-full py-4 px-5 text-base text-white-important font-bold text-left bg-transparent border-0 rounded-none transition focus:outline-none"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseOne"
                  aria-expanded="false"
                  aria-controls="collapseOne"
                >
                  Genç Yetenek Programına kimler katılabilir?
                </button>
              </h2>
              <div
                id="collapseOne"
                className="accordion-collapse collapse"
                aria-labelledby="1"
                data-bs-parent="#faq-accordion"
              >
                <div className="accordion-body py-4 px-5 text-custom-cyan font-normal text-lg">
                  <a href="#who-can-join" className="hover:text-cyan-400">
                    Kimler Katılabilir?
                  </a>{" "}
                  sekmesinden detayları inceleyebilirsin.
                </div>
              </div>
            </div>
            <div className="accordion-item bg-transparent border rounded-none border-white ">
              <h2 className="accordion-header mb-0" id="2">
                <button
                  className="accordion-button collapsed relative flex items-center w-full py-4 px-5 text-base text-white-important font-bold text-left bg-transparent border-0 rounded-none transition focus:outline-none"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTwo"
                  aria-expanded="false"
                  aria-controls="collapseTwo"
                >
                  Türkiye’deki bütün üniversite öğrencileri başvurabilir mi?
                </button>
              </h2>
              <div
                id="collapseTwo"
                className="accordion-collapse collapse"
                aria-labelledby="2"
                data-bs-parent="#faq-accordion"
              >
                <div className="accordion-body py-4 px-5 text-custom-cyan font-normal text-lg">
                  Tüm üniversitelerden başvuru kabul ediliyor.
                </div>
              </div>
            </div>
            <div className="accordion-item bg-transparent border rounded-none border-white ">
              <h2 className="accordion-header mb-0" id="3">
                <button
                  className="accordion-button collapsed relative flex items-center w-full py-4 px-5 text-base text-white-important font-bold text-left bg-transparent border-0 rounded-none transition focus:outline-none"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseThree"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                >
                  Programa başvurduktan sonra hangi aşamalara dahil olacağım?
                </button>
              </h2>
              <div
                id="collapseThree"
                className="accordion-collapse collapse"
                aria-labelledby="3"
                data-bs-parent="#faq-accordion"
              >
                <div className="accordion-body py-4 px-5 text-custom-cyan font-normal text-lg">
                  Programa başvurduktan sonra, online değerlendirme
                  aşamalarımızla ilgili seni bilgilendireceğiz.
                  <ul className="my-3">
                    <li>- İnsan Kaynakları görüşmesi</li>
                    <li>- Departman yöneticisi görüşmesi</li>
                    <li>- Kişilik envanteri</li>
                    <li>- İngilizce testi</li>
                  </ul>
                  Tüm aşamaları başarıyla tamamlayan adaylar değerlendirme
                  sürecini tamamlamış olacaklardır.
                </div>
              </div>
            </div>
            <div className="accordion-item bg-transparent border rounded-none border-white ">
              <h2 className="accordion-header mb-0" id="4">
                <button
                  className="accordion-button collapsed relative flex items-center w-full py-4 px-5 text-base text-white-important font-bold text-left bg-transparent border-0 rounded-none transition focus:outline-none"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseFour"
                  aria-expanded="false"
                  aria-controls="collapseFour"
                >
                  Rotasyon süreci nasıl gerçekleşecek?
                </button>
              </h2>
              <div
                id="collapseFour"
                className="accordion-collapse collapse"
                aria-labelledby="4"
                data-bs-parent="#faq-accordion"
              >
                <div className="accordion-body py-4 px-5 text-custom-cyan font-normal text-lg">
                  İlk olarak atandığın departmanda 6 ayını tamamladıktan sonra
                  farklı bir departman deneyimlemek istersen yeni departmanında
                  6 aylık serüvenin başlayacaktır.
                </div>
              </div>
            </div>
            <div className="accordion-item bg-transparent border rounded-none border-white ">
              <h2 className="accordion-header mb-0" id="5">
                <button
                  className="accordion-button collapsed relative flex items-center w-full py-4 px-5 text-base text-white-important font-bold text-left bg-transparent border-0 rounded-none transition focus:outline-none"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseFive"
                  aria-expanded="false"
                  aria-controls="collapseFive"
                >
                  Herhangi bir sorun yaşarsam nasıl iletişime geçerim?
                </button>
              </h2>
              <div
                id="collapseFive"
                className="accordion-collapse collapse"
                aria-labelledby="5"
                data-bs-parent="#faq-accordion"
              >
                <div className="accordion-body py-4 px-5 text-custom-cyan font-normal text-md sm:text-lg">
                  Tüm soruların için{" "}
                  <a
                    className="text-gray-900 decora font-semibold hover-text-custom-cyan"
                    href="mailto:geleceginrayinda@mtstaj.co"
                  >
                    geleceginrayinda@mtstaj.co
                  </a>
                  &nbsp; adresine mail atabilirsin.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
